exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] .icon[data-v-472e2f26]:hover {\n  cursor: pointer;\n}\n.muted[data-v-472e2f26] {\n  color: gray;\n  font-size: 80%;\n}\n", ""]);

// exports
